import { BaseError } from 'make-error-cause'

export default class TypingsError extends BaseError {
  name = 'TypingsError'
}
